export enum AddendumStatus {
  INACTIVE = 'inactive',
  ACTIVE = 'active',
  FAILED = 'failed',
}
